import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { select, Store } from '@ngrx/store';
import $ from 'jquery';
import { fromEvent, ReplaySubject, Subject } from 'rxjs';
import {
    pairwise,
    startWith,
    take,
    takeWhile,
    tap,
    throttleTime
} from 'rxjs/operators';
import Tabulator from 'tabulator-tables';
import * as fromShared from '../../shared';
import { getStatusIcon, Process } from '../../shared';
import { IShowErrors } from '../../shared/errors-sidenav';
import { UnsavedChangesService } from '../../shared/modal-dialog';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { TabulatorService } from '../../tabulator.service';
import { UserRoleEnum } from '../../user-info';
import * as fromUser from '../../user-info/store/user.reducer';
import {
    IGroup,
    IGroupElement,
    IGroupElementType,
    IGroupMember,
    IGroupType
} from '../IGroups';
import { GroupsAddComponent } from './groups-add/groups-add.component';
import { StateService } from '@uirouter/core';

@Component({
    selector: 'ef-groups-presenters',
    templateUrl: './groups-presenters.component.html',
    styleUrls: ['./groups-presenters.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class GroupsPresentersComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    public readonly getStatusIcon = getStatusIcon;
    public memberNameFilter = '';
    public elementNameFilter = '';
    public memberColumnVisibility: Record<string, boolean> = {
        assign: false,
        alt: false,
        altFor: false,
        IsAltSupervisorOnly: false,
        IsAltForAllSupervisors: false,
        AllowSuperUser: false,
        Allowauths: false,
        IsAdvisorAdmin: false,
        IsPrimary: false
    };
    public currentUserListId = '';
    private _groupmembers: Array<IGroupMember> = [];
    assignColumnHeader: string;
    assignedEleColumnHeader: any;
    showSelectedEleRowsOnly: boolean;
    switchDesc: string;
    memSwitchDesc: string;
    eleSwitchDesc: string;
    elementSelected = true;
    @Input() set groupMembers(value: Array<IGroupMember>) {
        this._groupmembers = value.map(x => ({ ...x }));
        this.membersArraySort(this._groupmembers);

        if (this.groupMembers.length > 0) {
            this.groupMembers.forEach(v => {
                v.selected = v.IsGroupMember;
            });
        }
        if (this.tabGroupMembers) {
            this.tabGroupMembers.replaceData(this._groupmembers);

            if (this.showSelectedRowsOnly === true) {
                this.filterdata();
            }

            if (this.showSelectedEleRowsOnly === true) {
                this.filterEleData();
            }

            this.checkIndeterminate(
                this.tabGroupMembers,
                this.membersCbxColumnHeader,
                this._groupmembers,
                0
            );
        }
        if (this.filterFormGroup.controls['purpose'].value) {
            this.purpose = this.filterFormGroup.controls['purpose']
                .value as string;
        }

        this.filteredMembers = this._groupmembers;
        this.loadingData = false;
    }
    get groupMembers(): Array<IGroupMember> {
        return this._groupmembers;
    }

    private _groupmembersorig: Array<IGroupMember>;
    @Input() set groupMembersORIG(value: Array<IGroupMember>) {
        this._groupmembersorig = value.map(x => ({ ...x }));
    }
    get groupMembersORIG(): Array<IGroupMember> {
        return this._groupmembersorig;
    }

    private _grouptypes: Array<IGroupType>;
    @Input() set groupTypes(value: Array<IGroupType>) {
        this._grouptypes = value.map(x => ({ ...x }));
        if (this.process) {
            if (this.process.ProcessID === 73) {
                this._grouptypes = this._grouptypes.filter(
                    type =>
                        type.Categoryid ===
                        'SYS000000000000000000000000000000000'
                );
                this.selectGroupType.emit(this._grouptypes[0]);
            } else {
                this._grouptypes = this._grouptypes.filter(
                    type =>
                        type.Categoryid !==
                        'SYS000000000000000000000000000000000'
                );
            }
        }
    }
    get groupTypes(): Array<IGroupType> {
        return this._grouptypes;
    }

    private _groupelementtypes: Array<IGroupElementType>;
    @Input() set groupElementTypes(value: Array<IGroupElementType>) {
        this._groupelementtypes = value.map(x => ({ ...x }));
        if (value.length > 0) {
            this.filterFormGroup.controls['elementTypes'].enable();
        } else {
            this.filterFormGroup.controls['elementTypes'].disable();
        }
    }
    get groupElementTypes(): Array<IGroupElementType> {
        return this._groupelementtypes;
    }

    private _groupelements: Array<IGroupElement> = [];
    @Input() set groupElements(value: Array<IGroupElement>) {
        this._groupelements = value.map(x => ({ ...x }));
        this.elementsArraySort(this._groupelements);
        if (this.groupElements.length > 0) {
            this.groupElements.forEach(v => {
                v.selected = v.IsGroupElement;
            });
        }
        if (this.tabElements) {
            this.tabElements.replaceData(this._groupelements);

            if (this.showSelectedEleRowsOnly === true) {
                this.filterEleData();
            }

            this.checkIndeterminate(
                this.tabElements,
                this.elementsCbxColumnHeader,
                this._groupelements,
                0
            );
        }
        this.loadingData = false;
    }
    get groupElements(): Array<IGroupElement> {
        return this._groupelements;
    }

    private _groupelementsorig: Array<IGroupElement>;
    @Input('groupElementsORIG') set groupElementsORIG(
        value: Array<IGroupElement>
    ) {
        this._groupelementsorig = value.map(x => ({ ...x }));
    }
    get groupElementsORIG(): Array<IGroupElement> {
        return this._groupelementsorig;
    }

    private _groups: Array<IGroup>;
    @Input('group') set groups(value: Array<IGroup>) {
        this._groups = value.map(x => ({ ...x }));
        if (value && value.length > 0) {
            if (this.process.ProcessID == 141) {
                this.processToggleText = value.find(
                    x => x.GroupID == 12029
                ).Purpose;
                this.setProcessRole(
                    this.getProcessRole(this.process.ProcessID)
                );
            }
        }
        this.loadingData = false;
        this.createTabulatorForElements(this, [], []);
    }
    get groups(): Array<IGroup> {
        return this._groups;
    }

    private HighlightErrorSubject = new Subject<IShowErrors>();
    private _selectedError: IShowErrors;
    @Input() public set selectedError(value: IShowErrors) {
        this._selectedError = value;
        if (this.tabGroupMembers && this.process) {
            if (value.MsgProcessID === this.process.ProcessID) {
                this.HighlightErrorSubject.next(value);
            }
        }
    }
    public get selectedError(): IShowErrors {
        return this._selectedError;
    }

    @Input() public process: Process;
    /** Licensed administrator limit; omit or null until loaded from API. */
    @Input() public adminCount: number | null = null;
    public showAssignAdminPopup = false;
    public showAdminCountExceededPopup = false;
    public roleID: number;
    public rolefromShared;
    public dropdownPlaceholderText = '';
    public selectNotificationText = '';
    public IsSupervisor = false;
    public IsTaskManager = false;
    public HasElements = false;
    public showBulkAssignButtons = true;
    public IsManageRoles: boolean;
    public active = true;
    public showSelectedRowsOnly = false;
    public selectColumnWidth = 107;
    public memberColumnTitle;
    public elementColumnHeader = 'Group Element';
    public purpose = '';
    public selectedGroup: IGroup;
    public supervisorListID = '';
    public membersSelectedRowsCheckbox = {
        checked: false,
        indeterminate: false
    };
    public elementsSelectedRowsCheckbox = {
        checked: false,
        indeterminate: false
    };
    public superUserCbx = { checked: false, indeterminate: false };
    public elementsCheckboxFlag = true;
    public superuserCbxFlag = false;
    public loadingData = true;
    public groupHeaderInitialized = false;

    public tabGroupMembers;
    public tabElements;

    public filterFormGroup: UntypedFormGroup;
    public caFilterFormGroup: UntypedFormGroup;
    public maintenanceFormGroup: UntypedFormGroup;

    processToggle = false;
    processToggleText: string; // = 'Provides members of custom security groups access to all users/contracts within their assigned processes.';
    showProcessToggle = false;

    @ViewChild('selectAllMembers', { read: ElementRef, static: true })
    membersSelectAllButton: ElementRef;
    @ViewChild('dontSelectAllMembers', { read: ElementRef, static: true })
    membersDontSelectAllButton: ElementRef;
    @ViewChild('selectAllElements', { read: ElementRef, static: true })
    elementsSelectAllButton: ElementRef;
    @ViewChild('dontSelectAllElements', { read: ElementRef, static: true })
    elementsDontSelectAllButton: ElementRef;
    @ViewChild('membersCbxColumnHeader', { static: true })
    membersCbxColumnHeader: MatCheckbox;
    @ViewChild('superuserCbx', { static: true }) superuserCbx: MatCheckbox;
    @ViewChild('elementsCbxColumnHeader', { static: true })
    elementsCbxColumnHeader: MatCheckbox;
    @ViewChild('addGroup', { read: ElementRef, static: true })
    addGroupButton: ElementRef;
    @ViewChild('deleteGroup', { read: ElementRef, static: true })
    deleteGroupButton: ElementRef;

    @Output() selectGroupType = new EventEmitter<IGroupType>();
    @Output() selectGroup = new EventEmitter<IGroup>();
    @Output() selectElement = new EventEmitter<IGroupElementType>();
    @Output() toggleMode = new EventEmitter<boolean>();
    @Output() toggleModeRoles = new EventEmitter<boolean>();
    @Output() memberRowSelectUpdate = new EventEmitter<Array<IGroupMember>>();
    @Output() elementRowSelectUpdate = new EventEmitter<Array<IGroupElement>>();
    @Output() resetData = new EventEmitter();
    @Output() deleteGroup = new EventEmitter<IGroup>();
    @Output() public Cancel = new EventEmitter();
    @Output() public ShowError = new Subject<IShowErrors>();

    @Output() LoadMembers = new ReplaySubject<any>(1);

    public assignAll = false;
    public unassignAll = false;

    rowsToUnassign: any[] = [];

    deleteDisabled = true;

    assignAreYouSureMsg: string;
    showAssignAreYouSure = false;
    rowDatafromAssign: IGroupMember;
    rowFromAssign: any;

    filteredMember: IGroupMember;
    filteredMembers: IGroupMember[] = [];

    deleteVisible = false;
    showElementSelectAllConfirmation = false;
    showMemberSelectAllConfirmation = false;

    constructor(
        @Inject(LoggingService) private log: LoggingService,
        @Inject(TabulatorService) private tabService: TabulatorService,
        private errorStore: Store<fromShared.Errors.State>,
        private dialog: MatDialog,
        @Inject(UnsavedChangesService)
        private confirmservice: UnsavedChangesService,
        private stateService: StateService
    ) {
        this.filterFormGroup = new UntypedFormGroup({
            reportadmin: new UntypedFormControl(this.processToggle),
            processadmin: new UntypedFormControl(this.processToggle),
            showSelectedToggle: new UntypedFormControl(null),
            showSelectedEleToggle: new UntypedFormControl(null),
            groupTypes: new UntypedFormControl(null),
            groups: new UntypedFormControl({
                Categoryid: '',
                GroupID: 0,
                GroupName: '',
                Purpose: ''
            }),
            purpose: new UntypedFormControl(null),
            elementTypes: new UntypedFormControl(null)
        });

        this.caFilterFormGroup = new UntypedFormGroup({
            reportadmin: new UntypedFormControl(this.processToggle),
            processadmin: new UntypedFormControl(this.processToggle)
        });

        this.maintenanceFormGroup = new UntypedFormGroup({
            maintenanceToggle: new UntypedFormControl(null)
        });
    }
    // search(event: fromShared.AutoCompleteCompleteEvent) {
    //     let filtered: any[] = [];
    //     let query = event.query;

    //     for (let i = 0; i < (this.groupMembers as IGroupMember[]).length; i++) {
    //         let member = (this.groupMembers as IGroupMember[])[i];
    //         if (member.UserName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
    //             filtered.push(member);
    //         }
    //     }

    //     this.filteredMembers = filtered;
    //     this.createTabulatorForGroupMembers(
    //         this,
    //         this.filteredMembers,
    //         []
    //     );
    // }
    addGroupClicked() {
        this.addPopup();
    }
    showDelete() {
        if (this.selectedGroup) {
            this.deleteVisible = true;
        }
    }
    deleteGroupClicked() {
        this.deleteGroup.emit(this.selectedGroup);
        this.resetPageToInitialState();
    }
    ngOnInit() {
        this.errorStore
            .pipe(
                select(fromUser.getUserInfo),
                takeWhile(() => this.active)
            )
            .subscribe(userInfo => {
                this.currentUserListId = userInfo?.EmployeeListID ?? '';
            });

        if (this.process) {
            this.log.verbose(this.process);

            if (this.process.ProcessID === 63) {
                this.IsManageRoles = false;
                this.dropdownPlaceholderText = 'Group Name';
                $('#maintenancePanel').fadeIn(0);
            } else {
                this.IsManageRoles = true;
                this.dropdownPlaceholderText = 'Role';
            }
        }
        this.caFilterFormGroup.controls['reportadmin'].patchValue('reportadmin');
        // fromEvent(this.addGroupButton.nativeElement, 'click')
        //     .pipe(
        //         tap(_ =>
        //             this.log.debug({
        //                 type: 'GroupsPresentersComponent:addGroupButton:click'
        //             })
        //         ),
        //         takeWhile(_ => this.active)
        //     )
        //     .subscribe(button => {
        //         try {
        //             this.addPopup();
        //         } catch (e) {
        //             this.log.verbose(e);
        //         }
        //     });

        // fromEvent(this.deleteGroupButton.nativeElement, 'click')
        //     .pipe(
        //         tap(_ =>
        //             this.log.debug({
        //                 type: 'GroupsPresentersComponent:deleteGroupButton:click'
        //             })
        //         ),
        //         takeWhile(_ => this.active)
        //     )
        //     .subscribe(button => {
        //         this.confirmservice
        //             .confirmPromise({
        //                 dialogText:
        //                     'Are you sure you want to delete the selected group?',
        //                 okText: 'Yes',
        //                 cancelText: 'No'
        //             })
        //             .then(() => {
        //                 this.deleteGroup.emit(this.selectedGroup);
        //                 this.filterFormGroup.controls['groups'].reset();
        //                 this.filterFormGroup.controls['elementTypes'].reset();
        //                 this.filterFormGroup.controls['purpose'].reset();
        //                 this.loadingData = false;
        //             })
        //             .catch(() => {});
        //     });
    }

    getProcessRole(processID: number): UserRoleEnum {
        this.showBulkAssignButtons = processID !== 139;
        switch (processID) {
            case 139:
                this.roleID = UserRoleEnum.Administrator;
                this.assignColumnHeader = `Assigned <br/>Admin`;
                this.memSwitchDesc = 'Display Assigned Admins Only';
                this.selectColumnWidth = 90;
                this.HasElements = false;
                break;
            case 73:
                this.roleID = UserRoleEnum.Supervisor;
                this.HasElements = true;
                this.assignColumnHeader = `Assigned <br/>Supervisor`;
                this.memSwitchDesc = 'Display Assigned Supervisors Only';
                this.selectColumnWidth = 87;
                break;
            case 140:
                this.roleID = UserRoleEnum.TaskManager;
                this.HasElements = true;
                this.assignColumnHeader = `Assigned <br/>Project Manager`;
                this.memSwitchDesc = 'Display Assigned Managers Only';
                this.selectColumnWidth = 107;
                break;
            case 141:
                let group;
                this.showProcessToggle = true;
                if (this.processToggle == false) {
                    if (this.groups.length > 0) {
                        group = this.groups.find(x => x.GroupID == 12029);
                        this.roleID = UserRoleEnum.ReportAdmin;

                        this.assignColumnHeader = `Assigned <br/>${group.GroupName}`;
                        this.memSwitchDesc =
                            'Display Assigned Report Admins Only';
                        this.selectColumnWidth = 105;
                    }

                } else {
                    if (this.groups.length > 0) {
                        group = this.groups.find(x => x.GroupID == 12023);
                        this.roleID = UserRoleEnum.ProcessAdmin;

                        this.assignColumnHeader = `Assigned <br/>${group.GroupName}`;
                        this.memSwitchDesc =
                            'Display Assigned Process Admins Only';
                        this.selectColumnWidth = 105;
                    }

                }
                if (this.tabGroupMembers != null) {
                    this.tabGroupMembers.updateColumnDefinition('selected', {
                        title: this.assignColumnHeader
                    });
                }
                this.HasElements = false;
                break;
            case 142:
                this.roleID = UserRoleEnum.Subcontractor;
                this.HasElements = true;
                this.assignColumnHeader = `Assigned <br/>Subcontractor`;
                this.memSwitchDesc = 'Display Assigned Subcontractors Only';
                this.selectColumnWidth = 105;
                break;
            default:
                this.assignColumnHeader = `Assigned <br/>Member`;
                this.assignedEleColumnHeader = `Assigned <br/>Item`;
                this.memSwitchDesc = 'Display Assigned Members Only';
                this.eleSwitchDesc = 'Display Assigned Items Only';
                this.selectColumnWidth = 90;
                this.HasElements = true;

                break;
        }
        this.rolefromShared = this.roleID;
        return this.roleID;
    }

    setProcessRole(roleId) {
        if (roleId === 1) {
            this.selectedGroup = {
                Categoryid: 'SYS000000000000000000000000000000000',
                GroupID: 1,
                GroupName: 'Administration',
                Purpose: 'Full access to all eFAACT features.'
            };
            this.purpose = this.selectedGroup.Purpose;
            this.filterFormGroup.patchValue({ groups: this.selectedGroup });
        } else if (roleId === 12024) {
            this.selectedGroup = {
                Categoryid: 'SYS000000000000000000000000000000000',
                GroupID: 12024,
                GroupName: 'Supervisor',
                Purpose:
                    'Provides access to review and approve time and expenses for assigned direct reports.'
            };
            this.purpose = this.selectedGroup.Purpose;
            this.filterFormGroup.patchValue({ groups: this.selectedGroup });
        } else if (roleId === 12025) {
            this.selectedGroup = {
                Categoryid: 'SYS000000000000000000000000000000000',
                GroupID: 12025,
                GroupName: 'Task Manager',
                Purpose:
                    'Provides access to review and approve time and expenses for assigned tasks.'
            };
            this.purpose = this.selectedGroup.Purpose;
            this.filterFormGroup.patchValue({ groups: this.selectedGroup });
        } else if (roleId === 12029) {
            this.log.verbose('process: ' + this.process);
            this.selectedGroup = this.groups.find(x => x.GroupID == 12029);
            this.processToggleText = this.selectedGroup.Purpose;
            this.purpose = this.selectedGroup.Purpose;
            this.filterFormGroup.patchValue({ groups: this.selectedGroup });
        } else if (roleId === 12023) {
            this.selectedGroup = this.groups.find(x => x.GroupID == 12023);
            this.processToggleText = this.selectedGroup.Purpose;
            this.purpose = this.selectedGroup.Purpose;
            this.filterFormGroup.patchValue({ groups: this.selectedGroup });
        } else if (roleId === 12030) {
            this.selectedGroup = {
                Categoryid: 'SYS000000000000000000000000000000000',
                GroupID: 12030,
                GroupName: 'Subcontractor',
                Purpose:
                    'Identify vendors that are a subcontrator that can be assigned consultants'
            };
            this.purpose = this.selectedGroup.Purpose;
            this.filterFormGroup.patchValue({ groups: this.selectedGroup });
        } else {
            // Do nothing
        }
        this.groupHeaderInitialized = true;
    }

    onProcessToggle(e: MatSlideToggleChange) {
        if (e.checked === true) {
            this.processToggle = true;
        } else {
            this.processToggle = false;
        }
    }

    onReportAdminRadioButtonClicked() {
        this.processToggle = false;
    }

    onCustomProcessAdminRadioButtonClicked() {
        this.processToggle = true;
    }

    ngOnDestroy() {
        this.active = false;
        this.resetData.emit();
    }

    ngAfterViewInit(): void {
        if (this.groupElements == null) {
            this.groupElements = [];
        }

        this.tabService.tabulator = $('#tabGroupMembers');
        this.tabService.tabulator = $('#tabElements');

        if (this.process) {
            setTimeout(() => {
                this.setProcessRole(
                    this.getProcessRole(this.process.ProcessID)
                );
                this.createTabulatorForGroupMembers(
                    this,
                    this.filteredMembers,
                    []
                );
                this.setupSubscriptions();
            }, 0);

            setTimeout(() => {
                this.createTabulatorForElements(this, this.groupElements, []);
            }, 1000);
        }
    }

    assignAdminWarningAccepted() {
        this.showAssignAdminPopup = false;
    }

    adminCountExceededWarningAccepted() {
        this.showAdminCountExceededPopup = false;
    }

    navigateToEfaactStore(): void {
        this.showAdminCountExceededPopup = false;
        this.stateService.go('efaactstore');
    }

    public get isAdministratorRolesPage(): boolean {
        return this.process?.ProcessID === 139;
    }

    public get isCurrentUserPrimaryAdmin(): boolean {
        const listId = (this.currentUserListId ?? '').trim();
        if (!listId) {
            return false;
        }
        return (this.groupMembers ?? []).some(
            member =>
                (member.ListID ?? '').trim().toLowerCase() ===
                    listId.toLowerCase() &&
                this.isPrimaryAdmin(member)
        );
    }

    public get adminCountExceededMessage(): string {
        const limit = this.adminCount ?? 0;
        const assigned = this.getAssignedAdministratorCount();
        return (
            `Administrator limit reached. Your license allows ` +
            `${limit} administrator${limit === 1 ? '' : 's'}, and all positions are currently assigned. ` + 
            `Please remove an existing administrator or upgrade your license to add another.`
        );
    }

    getAssignedAdministratorCount(): number {
        // Licensed administrator slots exclude certified advisors.
        return (this.groupMembers ?? []).filter(
            m => this.isMemberAssigned(m) && !this.isCertifiedAdvisor(m)
        ).length;
    }

    getAdvisorAdminCount(): number {
        return (this.groupMembers ?? []).filter(m => this.isCertifiedAdvisor(m))
            .length;
    }

    getAssignedAdvisorAdminCount(): number {
        return (this.groupMembers ?? []).filter(
            m => this.isMemberAssigned(m) && this.isCertifiedAdvisor(m)
        ).length;
    }

    private isMemberAssigned(member: IGroupMember | null | undefined): boolean {
        if (!member) {
            return false;
        }
        return (
            member.IsGroupMember === true ||
            (member as { IsGroupMember?: unknown }).IsGroupMember === 1
        );
    }

    private isCertifiedAdvisor(member: IGroupMember | null | undefined): boolean {
        if (!member) {
            return false;
        }
        return (
            member.IsAdvisorAdmin === true ||
            (member as { IsAdvisorAdmin?: unknown }).IsAdvisorAdmin === 1
        );
    }

    public isPrimaryAdmin(member: IGroupMember | null | undefined): boolean {
        if (!member) {
            return false;
        }
        return (
            member.IsPrimary === true ||
            (member as { IsPrimary?: unknown }).IsPrimary === 1
        );
    }

    private isAdminCountLimitConfigured(): boolean {
        return this.adminCount != null && !Number.isNaN(this.adminCount);
    }

    private wouldExceedAdminCountLimit(member: IGroupMember): boolean {
        if (!this.isAdminCountLimitConfigured() || Number(member.GroupID) !== 1) {
            return false;
        }
        // Certified advisors do not consume licensed administrator slots.
        if (this.isCertifiedAdvisor(member)) {
            return false;
        }
        if (this.isMemberAssigned(member)) {
            return false;
        }
        return this.getAssignedAdministratorCount() >= this.adminCount;
    }

    setupSubscriptions() {
        this.HighlightErrorSubject.pipe(
            takeWhile(() => this.active),
            startWith(null),
            pairwise()
        ).subscribe(([prev, next]) => {
            this.log.verbose({
                type: 'GroupsComponent:HighlightErrorSubject',
                prev,
                next
            });
            if (prev) {
                const prevRow = this.tabGroupMembers
                    .getRows()
                    .find(
                        row => row.getData().EmployeeListID === prev.MsgEntityID
                    );
                if (prevRow) {
                    prevRow.getElement().classList.remove('highlight');
                }
            }
            if (next) {
                const theRow = this.tabGroupMembers
                    .getRows()
                    .find(
                        row => row.getData().EmployeeListID === next.MsgEntityID
                    );
                if (theRow) {
                    theRow.getElement().classList.add('highlight');
                    this.log.debug({
                        type: 'GroupsComponent:selectedError:set',
                        rowElement: theRow.getElement()
                    });
                }
            }
        });

        this.caFilterFormGroup.controls['reportadmin'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value == 'reportadmin') {
                    this.processToggle = false;
                    this.caFilterFormGroup.controls['processadmin'].patchValue(
                        null
                    );
                } else {
                    this.processToggle = true;
                }
                this.setProcessRole(
                    this.getProcessRole(this.process.ProcessID)
                );
            });
        this.caFilterFormGroup.controls['processadmin'].valueChanges
            .pipe(takeWhile(_ => this.active))
            .subscribe(value => {
                if (value == 'processadmin') {
                    this.processToggle = true;
                    this.caFilterFormGroup.controls['reportadmin'].patchValue(
                        null
                    );
                } else {
                    this.processToggle = false;
                }
                this.setProcessRole(
                    this.getProcessRole(this.process.ProcessID)
                );
            });

        this.filterFormGroup.controls['groupTypes'].valueChanges
            .pipe(
                startWith(this.filterFormGroup.controls['groupTypes'].value),
                takeWhile(_ => this.active),
                tap(value =>
                    this.log.debug({
                        type: 'GroupsPresentersComponent:groupTypes:valueChanges:tap',
                        value
                    })
                )
            )
            .subscribe(value => {
                this.log.debug({
                    type: 'GroupsPresentersComponent:groupTypes:valueChanges:subscribe',
                    value
                });

                if (value != null) {
                    if (
                        value.Categoryid === '[users_listid]' ||
                        value.Categoryid ===
                            'SYS000000000000000000000000000000000'
                    ) {
                        this.filterFormGroup.controls['elementTypes'].disable();
                    } else {
                        this.filterFormGroup.controls['elementTypes'].enable();
                    }
                }
                if (this.filterFormGroup.controls['groups'].value != null) {
                    this.filterFormGroup.controls['groups'].reset();
                }

                if (this.tabGroupMembers) {
                    this.createTabulatorForGroupMembers(this, [], []);
                }
                this.purpose = '';

                this.selectGroupType.emit(value);

                this.membersCbxColumnHeader.indeterminate = false;
                this.membersCbxColumnHeader.checked = false;
                this.elementsCbxColumnHeader.indeterminate = false;
                this.elementsCbxColumnHeader.checked = false;
            });

        this.filterFormGroup.controls['groups'].valueChanges
            .pipe(
                startWith(this.selectedGroup),
                takeWhile(_ => this.active),
                tap(value =>
                    this.log.debug({
                        type: 'GroupsPresentersComponent:groups:valueChanges:tap',
                        value
                    })
                )
            )
            .subscribe(value => {
                this.log.debug({
                    type: 'GroupsPresentersComponent:groups:valueChanges:subscribe',
                    value
                });
                this.loadingData = true;
                this.filterFormGroup.controls['elementTypes'].reset();
                if (this.IsManageRoles === false) {
                    this.selectedGroup = value;
                }

                this.memberColumnTitle = `${this.selectedGroup} Group Member`;
                if (value != null) {
                    if (this.groupElementTypes.length > 0) {
                        this.filterFormGroup.controls[
                            'elementTypes'
                        ].patchValue(
                            this.groupElementTypes[0].GroupElementType
                        );
                    }
                    this.purpose = value.Purpose;

                    if (value.GroupID === 12024) {
                        this.elementsCheckboxFlag = false;
                        this.IsSupervisor = true;
                        this.tabGroupMembers.showColumn('IsAltSupervisorOnly');
                        this.tabGroupMembers.showColumn('assign');
                        this.tabGroupMembers.showColumn('alt');
                        this.tabGroupMembers.showColumn('altFor');
                        this.tabGroupMembers.showColumn('AllowSuperUser');
                        this.tabGroupMembers.showColumn('Allowauths');
                        this.tabGroupMembers.hideColumn('IsPrimary');
                        this.tabGroupMembers.hideColumn(
                            'IsAltForAllSupervisors'
                        );
                    } else if (
                        value.GroupID !== 12024 ||
                        value.GroupID !== 12025
                    ) {
                        this.elementsCheckboxFlag = true;
                        this.tabGroupMembers.hideColumn('IsAltSupervisorOnly');
                        this.tabGroupMembers.hideColumn('assign');
                        this.tabGroupMembers.hideColumn('alt');
                        this.tabGroupMembers.hideColumn('altFor');
                        if (value.GroupID !== 1) {
                            this.tabGroupMembers.hideColumn('AllowSuperUser');
                            this.tabGroupMembers.hideColumn('IsAdvisorAdmin');
                            this.tabGroupMembers.hideColumn('IsPrimary');
                            this.tabGroupMembers.hideColumn('Allowauths');
                            this.tabGroupMembers.hideColumn(
                                'IsAltForAllSupervisors'
                            );
                        }
                    }
                    if (value.GroupID === 1) {
                        this.tabGroupMembers.hideColumn('IsAltSupervisorOnly');
                        this.tabGroupMembers.showColumn('AllowSuperUser');
                        this.tabGroupMembers.showColumn('IsAdvisorAdmin');
                        this.tabGroupMembers.showColumn('IsPrimary');
                        // this.tabGroupMembers.showColumn('Allowauths');
                        // this.tabGroupMembers.showColumn('assign');
                        this.tabGroupMembers.showColumn(
                            'IsAltForAllSupervisors'
                        );
                    }

                    if (value.GroupID === 12025) {
                        this.elementsCheckboxFlag = false;
                        this.IsTaskManager = true;
                        this.tabGroupMembers.hideColumn('IsAltSupervisorOnly');
                        this.tabGroupMembers.showColumn('assign');
                        this.tabGroupMembers.hideColumn(
                            'IsAltForAllSupervisors'
                        );
                    }
                    if (value.GroupID === 12030) {
                        this.elementsCheckboxFlag = false;
                        this.tabGroupMembers.hideColumn('IsAltSupervisorOnly');
                        this.tabGroupMembers.showColumn('assign');
                        this.tabGroupMembers.hideColumn(
                            'IsAltForAllSupervisors'
                        );
                    }
                }
                this.groupMembersORIG = [];
                this.groupElementsORIG = [];

                if (this.showSelectedRowsOnly === true) {
                    this.filterdata();
                }

                this.membersCbxColumnHeader.indeterminate = false;
                this.membersCbxColumnHeader.checked = false;
                this.elementsCbxColumnHeader.indeterminate = false;
                this.elementsCbxColumnHeader.checked = false;
                this.selectGroup.emit(value);
                $('#purpose').fadeIn(500);
            });

        this.filterFormGroup.controls['elementTypes'].valueChanges
            .pipe(
                startWith([]),
                takeWhile(_ => this.active),
                tap(value =>
                    this.log.debug({
                        type: 'GroupsPresentersComponent:elementTypes:valueChanges:tap',
                        value
                    })
                )
            )
            .subscribe(value => {
                this.log.debug({
                    type: 'GroupsPresentersComponent:elementTypes:valueChanges:subscribe',
                    value
                });

                if (value != null) {
                    this.elementsCheckboxFlag = false;
                    this.selectElement.emit(value);
                    this.elementColumnHeader = value.GroupElementType;
                }
            });

        // Click event for the select all members button
        fromEvent(this.membersSelectAllButton.nativeElement, 'click')
            .pipe(
                takeWhile(_ => this.active),
                throttleTime(500),
                tap(_ =>
                    this.log.verbose({
                        type: 'GroupsPresentersComponent:selectAllMembers'
                    })
                )
            )
            .subscribe(x => {
                this.log.verbose({
                    type: 'GroupsPresentersComponent:selectAllMembers',
                    x
                });
                $('#divSelectAllMembers').hide();

                const headerFilters = this.tabGroupMembers.getHeaderFilters();
                if (headerFilters.length > 0) {
                    const headerFilterValue = headerFilters[0].value;
                    this.groupMembers.forEach(el => {
                        if (el.GroupName.includes(headerFilterValue) === true) {
                            el.selected = true;
                        }
                    });
                } else {
                    this.groupMembers = this.groupMembers.map(z => ({
                        ...z,
                        selected: true
                    }));
                }

                const numerOfRowsSelected =
                    this.tabGroupMembers.getSelectedData().length;

                const rows = this.tabGroupMembers.getRows(true);
                rows.forEach(row => {
                    const data = row.getData();
                    if (this.assignAll === true) {
                        if (data.selected === false) {
                            this.membersMultiUpdate(row);
                        }
                    } else {
                        if (data.selected === true) {
                            this.membersMultiUpdate(row);
                        }
                    }
                });
                const rowsData: Array<any> = [];
                rows.forEach(row => {
                    const rowData = row.getData();
                    rowsData.push(rowData);
                });
                this.memberRowSelectUpdate.emit(rowsData);
            });

        fromEvent(this.membersDontSelectAllButton.nativeElement, 'click')
            .pipe(
                takeWhile(_ => this.active),
                throttleTime(500),
                tap(_ =>
                    this.log.verbose({
                        type: 'GroupsPresentersComponent:dontSelectAllMembers'
                    })
                )
            )
            .subscribe(x => {
                this.log.verbose({
                    type: 'GroupsPresentersComponent:dontSelectAllMembers',
                    x
                });
                $('#divSelectAllMembers').hide();
                // reset header checkbox
                this.checkIndeterminate(
                    this.tabGroupMembers,
                    this.membersCbxColumnHeader,
                    this.groupMembers,
                    0
                );
            });

        // Click event for the select all elements button
        fromEvent(this.elementsSelectAllButton.nativeElement, 'click')
            .pipe(
                takeWhile(_ => this.active),
                throttleTime(500),
                tap(_ =>
                    this.log.verbose({
                        type: 'GroupsPresentersComponent:selectAllElements'
                    })
                )
            )
            .subscribe(x => {
                this.log.verbose({
                    type: 'GroupsPresentersComponent:selectAllElements',
                    x
                });
                $('#divSelectAllElements').hide();
                const headerFilters = this.tabElements.getHeaderFilters();
                if (headerFilters.length > 0) {
                    const headerFilterValue = headerFilters[0].value;
                    this.groupElements.forEach(el => {
                        if (
                            el.ElementName.includes(headerFilterValue) === true
                        ) {
                            el.selected = true;
                        }
                    });
                } else {
                    this.groupElements = this.groupElements.map(z => ({
                        ...z,
                        selected: true
                    }));
                }

                this.tabElements.selectRow();
                const numerOfRowsSelected =
                    this.tabElements.getSelectedData().length;

                const rows = this.tabElements.getRows(true);
                if (this.unassignAll == true) {
                    rows.forEach(row => {
                        const data = row.getData();
                        if (data.selected == true) {
                            this.elementsMultiUpdate(row);
                        }
                    });
                } else {
                    rows.forEach(row => {
                        const data = row.getData();
                        this.elementsMultiUpdate(row);
                    });
                }

                const rowsData: Array<any> = [];
                rows.forEach(row => {
                    const rowData = row.getData();
                    row.update({ ListID: this.supervisorListID });
                    rowsData.push(rowData);
                });
                this.elementRowSelectUpdate.emit(rowsData);
            });

        fromEvent(this.elementsDontSelectAllButton.nativeElement, 'click')
            .pipe(
                takeWhile(_ => this.active),
                throttleTime(500),
                tap(_ =>
                    this.log.verbose({
                        type: 'GroupsPresentersComponent:dontSelectAllElements'
                    })
                )
            )
            .subscribe(x => {
                this.log.verbose({
                    type: 'GroupsPresentersComponent:dontSelectAllElements',
                    x
                });
                $('#divSelectAllElements').hide();
            });
    }
    membersMultiUpdate(row) {
        row.update({ selected: true });
        const rowData = row.getData();
        const data = this.groupMembers.find(x => x.ListID === rowData.ListID);
        const rowIndex = row.getPosition(true);
        if (rowData.IsGroupMember !== rowData.selected) {
            if (rowData.IsGroupMember === true) {
                row.update({ IsGroupMember: false, selected: false });
            } else {
                row.update({ IsGroupMember: true, selected: true }); //potential issue here
            }
        } else {
            row.update({ IsGroupMember: false, selected: false });
        }
    }

    public get displayedGroupMembers(): Array<IGroupMember> {
        let rows = this.groupMembers ?? [];
        if (this.showSelectedRowsOnly) {
            rows = rows.filter(x => x.selected === true);
        }
        if (this.memberNameFilter?.trim()) {
            const filter = this.memberNameFilter.toLowerCase();
            rows = rows.filter(x => (x.UserName ?? '').toLowerCase().includes(filter));
        }
        return rows;
    }

    public get displayedGroupElements(): Array<IGroupElement> {
        let rows = this.groupElements ?? [];
        if (this.showSelectedEleRowsOnly) {
            rows = rows.filter(x => x.selected === true);
        }
        if (this.elementNameFilter?.trim()) {
            const filter = this.elementNameFilter.toLowerCase();
            rows = rows.filter(x => (x.ElementName ?? '').toLowerCase().includes(filter));
        }
        return rows;
    }

    public isMemberColumnVisible(column: string): boolean {
        return this.memberColumnVisibility[column] !== false;
    }

    public onMemberAssignedToggle(
        member: IGroupMember,
        event: Event
    ): void {
        event.preventDefault();
        event.stopPropagation();
        this.onMemberAssignedChange(member, !member.selected);
    }

    public onMemberAssignedChange(member: IGroupMember, checked: boolean) {
        if (checked && this.wouldExceedAdminCountLimit(member)) {
            this.showAdminCountExceededPopup = true;
            return;
        }

        member.selected = checked;

        const row = this.createTableRow(member, this.groupMembers, 'ListID');
        this.rowFromAssign = row;
        this.rowDatafromAssign = member;
        if (checked) {
            this.assignGroupMember();
            return;
        }

        if (member.GroupID === 12024) {
            this.assignAreYouSureMsg = `This will remove Supervisor permissions for ${member.UserName}.
            Reassign or remove their direct reports assignments prior to this change.`;
            this.showAssignAreYouSure = true;
            return;
        }
        if (member.GroupID === 12025) {
            this.assignAreYouSureMsg = `This will remove ${member.UserName} from the Task Manager role.
            If ${member.UserName} has tasks assigned,
            tasks assigned to ${member.UserName} must be removed or re-assigned before Task Manager role is removed.`;
            this.showAssignAreYouSure = true;
            return;
        }
        if (member.GroupID === 12030) {
            this.assignAreYouSureMsg = `This will remove ${member.UserName} as a Subcontractor.
            Consultants assigned to ${member.UserName} must be removed or re-assigned before Subcontractor role is removed.`;
            this.showAssignAreYouSure = true;
            return;
        }
        if (member.GroupID === 1) {
            this.assignAreYouSureMsg = `This will remove ${member.UserName} from the Administrator role.`;
            this.showAssignAreYouSure = true;
            return;
        }
        if (member.GroupID === 12029) {
            this.assignAreYouSureMsg = `This will remove ${member.UserName} from the Report Admin role.`;
            this.showAssignAreYouSure = true;
            return;
        }
        if (member.GroupID === 12023) {
            this.assignAreYouSureMsg = `This will remove ${member.UserName} from the Process Admin role.`;
            this.showAssignAreYouSure = true;
            return;
        }

        this.assignAreYouSureMsg = `This will remove ${member.UserName} from this group.`;
        this.showAssignAreYouSure = true;
    }

    public onMemberActionClick(member: IGroupMember) {
        const row = this.createTableRow(member, this.groupMembers, 'ListID');
        this.membersRowSelection(row, this.tabGroupMembers);
    }

    public onMemberAltClick(member: IGroupMember) {
        if (!(member.IsAltSupervisorOnly === false || member.IsAltSupervisorOnly == null)) {
            return;
        }

        this.assignedEleColumnHeader = `Assigned <br/>Alternate`;
        this.eleSwitchDesc = 'Display Assigned Alternates Only';
        this.elementSelected = false;
        this.supervisorListID = member.ListID;
        if (member.GroupID === 12024 && member.selected === true) {
            let index = 0;
            for (let i = 0; i < this.groupElementTypes.length; i++) {
                if (this.groupElementTypes[i].GroupElementTypeID === 9) {
                    index = i;
                }
            }
            this.elementColumnHeader = `${member.UserName}'s ${this.groupElementTypes[index].GroupElementType}s`;
            this.groupElementTypes[index].ListID = member.ListID;
            this.selectElement.emit(this.groupElementTypes[index]);
        }
    }

    public onMemberAltForClick(member: IGroupMember) {
        this.assignedEleColumnHeader = `Assigned <br/>Alternate For`;
        this.eleSwitchDesc = 'Display Assigned Alternates Only';
        this.elementSelected = false;
        this.supervisorListID = member.ListID;
        if (member.GroupID === 12024 && member.selected === true) {
            let altForIndex = 0;
            for (let i = 0; i < this.groupElementTypes.length; i++) {
                if (this.groupElementTypes[i].GroupElementTypeID === 10) {
                    altForIndex = i;
                }
            }
            this.elementColumnHeader = `${member.UserName} is an ${this.groupElementTypes[altForIndex].GroupElementType}`;
            this.groupElementTypes[altForIndex].ListID = member.ListID;
            this.selectElement.emit(this.groupElementTypes[altForIndex]);
        }
    }

    public onToggleMemberPermission(
        member: IGroupMember,
        field:
            | 'IsAltForAllSupervisors'
            | 'AllowSuperUser'
            | 'Allowauths',
        confirmMessage?: string
    ) {
        if (member.IsGroupMember !== true) {
            member[field] = !member[field];
            return;
        }

        const before = !member[field];
        const after = member[field];
        const shouldConfirmRemoval = before === true && after === false && Boolean(confirmMessage);

        const emitUpdate = () => this.memberRowSelectUpdate.emit([{ ...member }]);
        if (shouldConfirmRemoval) {
            this.confirmservice
                .confirmPromise({
                    headerText: 'Are you sure?',
                    dialogText: confirmMessage,
                    okText: 'Ok',
                    cancelText: 'Cancel'
                })
                .then(() => emitUpdate())
                .catch(() => {
                    member[field] = before;
                });
            return;
        }

        emitUpdate();
    }

    public onElementAssignedChange(element: IGroupElement) {
        const row = this.createTableRow(element, this.groupElements, 'GroupElementID');
        this.elementsMultiUpdate(row);
        this.elementRowSelectUpdate.emit([element]);
    }

    private createTableRow<T extends Record<string, any>>(
        rowData: T,
        source: Array<T>,
        idField: keyof T
    ) {
        return {
            getData: () => rowData,
            update: (patch: Partial<T>) => {
                Object.assign(rowData, patch);
                const key = rowData[idField];
                const sourceRow = source.find(x => x[idField] === key);
                if (sourceRow) {
                    Object.assign(sourceRow, patch);
                }
            },
            getPosition: () => source.findIndex(x => x[idField] === rowData[idField]),
            getElement: () => ({ classList: { add: () => undefined, remove: () => undefined } }),
            toggleSelect: () => {
                const next = !Boolean((rowData as any).selected);
                (rowData as any).selected = next;
            }
        };
    }

    private buildTableAdapter<T extends Record<string, any>>(
        source: () => Array<T>,
        idField: keyof T,
        selectedField: keyof T,
        filterGetter: () => string,
        visibility?: Record<string, boolean>
    ) {
        const rowFactory = (item: T) => this.createTableRow(item, source(), idField);

        return {
            replaceData: (items: Array<T>) => items,
            getRows: () => source().map(rowFactory),
            getSelectedData: () => source().filter(x => Boolean(x[selectedField])),
            getHeaderFilters: () =>
                filterGetter()?.trim() ? [{ value: filterGetter().trim() }] : [],
            clearFilter: () => undefined,
            setFilter: () => undefined,
            selectRow: () => undefined,
            clearData: () => {
                source().splice(0, source().length);
            },
            showColumn: (column: string) => {
                if (visibility) {
                    visibility[column] = true;
                }
            },
            hideColumn: (column: string) => {
                if (visibility) {
                    visibility[column] = false;
                }
            },
            updateColumnDefinition: () => undefined
        };
    }

    private getBulkOperationMembers(): Array<IGroupMember> {
        const members = this.groupMembers ?? [];
        const filter = this.memberNameFilter?.trim().toLowerCase();
        if (!filter) {
            return members;
        }

        return members.filter(member =>
            (member.UserName ?? '').toLowerCase().includes(filter)
        );
    }

    private getBulkOperationElements(): Array<IGroupElement> {
        const elements = this.groupElements ?? [];
        const filter = this.elementNameFilter?.trim().toLowerCase();
        if (!filter) {
            return elements;
        }

        return elements.filter(element =>
            (element.ElementName ?? '').toLowerCase().includes(filter)
        );
    }

    private buildMemberUpdatePayload(member: IGroupMember): IGroupMember {
        const source =
            this.groupMembers.find(x => x.ListID === member.ListID) ?? member;
        return {
            ...source,
            ...member,
            IsGroupMember: member.IsGroupMember,
            selected: member.selected
        };
    }

    private buildElementUpdatePayload(element: IGroupElement): IGroupElement {
        const source =
            this.groupElements.find(
                x => x.GroupElementID === element.GroupElementID
            ) ?? element;
        return {
            ...source,
            ...element,
            IsGroupElement: element.IsGroupElement,
            selected: element.selected,
            ListID: element.ListID
        };
    }

    private applyBulkMemberUpdates(assign: boolean): void {
        const targetMembers = this.getBulkOperationMembers();

        if (
            assign &&
            this.isAdminCountLimitConfigured() &&
            this.roleID === UserRoleEnum.Administrator
        ) {
            const newlyAssigned = targetMembers.filter(
                member =>
                    member.IsGroupMember !== true && !this.isCertifiedAdvisor(member)
            ).length;
            if (
                this.getAssignedAdministratorCount() + newlyAssigned >
                this.adminCount
            ) {
                this.showAdminCountExceededPopup = true;
                return;
            }
        }

        const payload: IGroupMember[] = [];

        targetMembers.forEach(member => {
            const shouldAssign = assign && member.IsGroupMember !== true;
            const shouldUnassign = !assign && member.IsGroupMember === true;
            if (!shouldAssign && !shouldUnassign) {
                return;
            }

            const row = this.createTableRow(member, this.groupMembers, 'ListID');
            this.membersMultiUpdate(row);
            payload.push(this.buildMemberUpdatePayload(row.getData()));
        });

        if (payload.length === 0) {
            return;
        }

        this.memberRowSelectUpdate.emit(payload);
        this.groupMembers = [...this.groupMembers];
    }

    private applyBulkElementUpdates(assign: boolean): void {
        const targetElements = this.getBulkOperationElements();
        const payload: IGroupElement[] = [];

        targetElements.forEach(element => {
            const shouldAssign = assign && element.IsGroupElement !== true;
            const shouldUnassign = !assign && element.IsGroupElement === true;
            if (!shouldAssign && !shouldUnassign) {
                return;
            }

            const row = this.createTableRow(
                element,
                this.groupElements,
                'GroupElementID'
            );
            this.assignAll = assign;
            this.unassignAll = !assign;
            this.elementsMultiUpdate(row);
            payload.push(this.buildElementUpdatePayload(row.getData()));
        });

        if (payload.length === 0) {
            return;
        }

        this.elementRowSelectUpdate.emit(payload);
        this.groupElements = [...this.groupElements];
    }

    elementsMultiUpdate(row) {
        row.update({ selected: true });
        const rowData = row.getData();
        const data = this.groupElements.find(
            x => x.GroupElementID === rowData.GroupElementID
        );
        if (rowData.IsGroupElement !== rowData.selected) {
            if (rowData.IsGroupElement === true) {
                row.update({
                    IsGroupElement: false,
                    selected: false,
                    ListID: this.supervisorListID
                });
            } else {
                row.update({
                    IsGroupElement: true,
                    selected: true,
                    ListID: this.supervisorListID
                });
            }
        } else {
            if (rowData.IsGroupElement === true) {
                if (this.assignAll === true) {
                    row.update({
                        IsGroupElement: true,
                        selected: true,
                        ListID: this.supervisorListID
                    });
                } else {
                    row.update({
                        IsGroupElement: false,
                        selected: false,
                        ListID: this.supervisorListID
                    });
                }
            } else {
                row.update({
                    IsGroupElement: true,
                    selected: true,
                    ListID: this.supervisorListID
                });
            }
        }
    }

    addPopup() {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            groupTypes: this.groupTypes,
            filterFormGroup: this.filterFormGroup
        };

        const addGroupsRef = this.dialog.open(GroupsAddComponent, dialogConfig);
        addGroupsRef
            .afterClosed()
            .pipe(take(1))
            .subscribe(data => {
                this.log.verbose({
                    type: 'GroupsAddComponent:afterClosed',
                    data
                });
            });
    }

    elementsArraySort(array: Array<any>) {
        array.sort((a, b) => {
            if (a.ElementName === b.ElementName) {
                return 0;
            }
            if (typeof a.ElementName === typeof b.ElementName) {
                return a.ElementName < b.ElementName ? -1 : 1;
            }
            return typeof a.ElementName < typeof b.ElementName ? -1 : 1;
        });
    }

    membersArraySort(array: Array<any>) {
        array.sort((a, b) => {
            if (a.UserName === b.UserName) {
                return 0;
            }
            if (typeof a.UserName === typeof b.UserName) {
                return a.UserName < b.UserName ? -1 : 1;
            }
            return typeof a.UserName < typeof b.UserName ? -1 : 1;
        });
    }

    filterData(filters) {
        if (this.tabGroupMembers) {
            this.tabGroupMembers.clearFilter(true);
        }

        if (this.tabElements) {
            this.tabElements.clearFilter(true);
        }

        const filtersToApply: Array<
            Array<{
                field: string;
                type: string;
                value: any;
            }>
        > = [[], []];

        if (filters && filters.length > 0) {
            filtersToApply[0].push({
                field: 'IsGroupMember',
                type: '=',
                value: true
            });
            filtersToApply[1].push({
                field: 'IsGroupElement',
                type: '=',
                value: true
            });

            if (this.tabGroupMembers) {
                this.tabGroupMembers.setFilter(filtersToApply[0]);
            }

            if (this.tabElements) {
                this.tabElements.setFilter(filtersToApply[1]);
            }
        }
    }

    membersRowSelection(row, tab) {
        // clear elements when a new member is selected
        if (this.IsSupervisor || this.IsTaskManager) {
            this.tabElements.clearData();
        }
        const allRows = this.tabGroupMembers.getRows();

        // SAME AS CLICKING THE DIRECT REPORTS BUTTON
        const data = row.getData();
        this.elementSelected = false;
        if (data.GroupID === 12024) {
            this.assignedEleColumnHeader = `Assigned <br/>Direct Report`;
            this.eleSwitchDesc = 'Display Assigned Direct Reports Only';
            this.elementColumnHeader = `${data.UserName}'s Direct Reports`;
        }
        if (data.GroupID === 12025) {
            this.assignedEleColumnHeader = `Assigned <br/>Tasks`;
            this.eleSwitchDesc = 'Display Assigned Tasks Only';
            this.elementColumnHeader = `${data.UserName}'s Tasks`;
        }
        if (data.GroupID === 12030) {
            this.assignedEleColumnHeader = `Assigned <br/>Consultants`;
            this.eleSwitchDesc = 'Display Assigned Consultants Only';
            this.elementColumnHeader = `${data.UserName}'s Consultants`;
        }

        this.supervisorListID = data.ListID;
        if (data.GroupID === 12024 || data.GroupID === 12030) {
            if (data.selected === true) {
                let index = 0;
                for (let i = 0; i < this.groupElementTypes.length; i++) {
                    if (this.groupElementTypes[i].GroupElementTypeID === 6) {
                        index = i;
                    }
                }
                if (
                    this.groupElementTypes[index].GroupElementType === 'Users'
                ) {
                    this.groupElementTypes[index].GroupElementType =
                        'Direct Reports';
                }
                this.elementsCheckboxFlag = false;
                this.groupElementTypes[index].ListID = data.ListID;
                this.selectElement.emit(this.groupElementTypes[index]);
            }
        }
        if (data.GroupID === 12025) {
            if (data.selected === true) {
                let index = 0;
                for (let i = 0; i < this.groupElementTypes.length; i++) {
                    if (data.GroupID === this.groupElementTypes[i].GroupID) {
                        index = i;
                    }
                }
                this.elementsCheckboxFlag = false;
                this.groupElementTypes[index].ListID = data.ListID;
                this.selectElement.emit(this.groupElementTypes[index]);
            }
        }
    }
    assignGroupMember() {
        const row = this.rowFromAssign;
        const rowData = this.rowDatafromAssign;
        row.update({ selected: true });
        const group = this.groupMembers.find(x => x.ListID === rowData.ListID);
        const rowIndex = row.getPosition(true);
        const allRows = this.tabGroupMembers.getRows();
        let selectedCount = 0;
        if (this.selectedGroup.GroupID === 1) {
            allRows.forEach(r => {
                const data = r.getData();
                // Last-admin protection applies only to licensed (non-advisor) admins.
                if (this.isMemberAssigned(data) && !this.isCertifiedAdvisor(data)) {
                    selectedCount++;
                }
            });
        }
        if (rowData.IsGroupMember !== rowData.selected) {
            if (rowData.IsGroupMember === true) {
                row.update({
                    IsGroupMember: false,
                    selected: false
                });
                this.memberRowSelectUpdate.emit([
                    {
                        ...group,
                        ...rowData
                    }
                ]);
            } else {
                if (rowData.GroupID === 1) {
                    if (this.wouldExceedAdminCountLimit(rowData)) {
                        row.update({
                            IsGroupMember: false,
                            selected: false
                        });
                        this.showAdminCountExceededPopup = true;
                        this.showAssignAreYouSure = false;
                        return;
                    }
                    this.confirmservice
                        .confirmPromise({
                            dialogText: `This will provide ${rowData.UserName} access to all features for all users and all contracts.`,
                            okText: 'Confirm',
                            cancelText: 'Cancel'
                        })
                        .then(() => {
                            row.update({
                                IsGroupMember: true,
                                selected: true
                            });
                            this.memberRowSelectUpdate.emit([
                                {
                                    ...group,
                                    ...rowData
                                }
                            ]);
                        })
                        .catch(() => {
                            row.update({
                                IsGroupMember: false,
                                selected: false
                            });
                        });
                } else {
                    row.update({
                        IsGroupMember: true,
                        selected: true
                    });
                    this.memberRowSelectUpdate.emit([
                        {
                            ...group,
                            ...rowData
                        }
                    ]);
                }
            }
        } else {
            if (this.rolefromShared === 1) {
                if (
                    !this.isCertifiedAdvisor(rowData) &&
                    selectedCount <= 1
                ) {
                    this.showAssignAdminPopup = true;
                } else {
                    row.update({
                        IsGroupMember: false,
                        selected: false
                    });
                    this.memberRowSelectUpdate.emit([
                        {
                            ...group,
                            ...rowData
                        }
                    ]);
                }
            } else {
                row.update({
                    IsGroupMember: false,
                    selected: false
                });
                this.memberRowSelectUpdate.emit([
                    {
                        ...group,
                        ...rowData
                    }
                ]);
            }
        }

        this.showAssignAreYouSure = false;
    }
    cancelAssignGroupMember() {
        this.showAssignAreYouSure = false;
    }

    private createTabulatorForGroupMembers(
        fp: GroupsPresentersComponent,
        groupMembers: Array<IGroupMember>,
        errors: Array<string>
    ) {
        this.tabGroupMembers = this.buildTableAdapter(
            () => this.groupMembers,
            'ListID',
            'selected',
            () => this.memberNameFilter,
            this.memberColumnVisibility
        );
        return;
        const headerClicked = false;

        this.tabGroupMembers = new Tabulator('#tabGroupMembers', {
            placeholder: 'No Data Available',
            height: '45vh',
            autoResize: true,
            layout: 'fitColumns',
            data: groupMembers,
            selectable: 1,
            columns: [
                {
                    title: 'Id',
                    field: 'ListID',
                    frozen: true,
                    visible: false
                },
                {
                    title: '',
                    titleFormatter: () =>
                        document.getElementById('divStatusHeader'),
                    field: 'Status',
                    align: 'center',
                    width: '3rem',
                    formatter: (cell, params, onRendered) => {
                        const status = cell.getValue();
                        if (status) {
                            if (status.StatusCode == 1) {
                                return `<i class='line-height-2 text-xl text-green-300 ${getStatusIcon(status.StatusCode).iconText}' title='${status.Message}'></i>`;
                            }
                            else if (status.StatusCode == 2) {
                                return `<i class='line-height-2 text-xl text-yellow-300 ${getStatusIcon(status.StatusCode).iconText}' title='${status.Message}'></i>`;
                            } else if (status.StatusCode == 3) {
                                return `<i class='line-height-2 text-xl text-red-300 ${getStatusIcon(status.StatusCode).iconText}' title='${status.Message}'></i>`;
                            }  else {
                                return getStatusIcon(status.StatusCode).iconText;
                            }
                        }
                    },
                    headerSort: false,
                    cellClick: function (e, cell) {
                        const status = cell.getValue();

                        if (status) {
                            switch (status.StatusCode) {
                                case 2:
                                    fp.ShowError.next({
                                        open: true,
                                        MsgEntityID: status.MsgEntityID
                                    });
                                case 3:
                                case 4:
                                case 5:
                                    fp.ShowError.next({
                                        open: true,
                                        MsgEntityID: status.MsgEntityID
                                    });
                            }
                        }
                    }
                },
                // Selected
                {
                    title: "Assigned",//this.assignColumnHeader,
                    field: 'selected',
                    headerSort: false,
                    align: 'center',
                    width: this.selectColumnWidth,
                    formatter: 'tickCross',
                    formatterParams: { crossElement: false },
                    editor: false,
                    selectablePersistence: false,
                    cellClick: (e, cell) => {
                        const row = cell.getRow();
                        fp.rowFromAssign = row;
                        // row.toggleSelect();
                        const rowData = row.getData();
                        fp.rowDatafromAssign = rowData;
                        if (
                            rowData.GroupID == 12024 &&
                            rowData.selected == true
                        ) {
                            fp.assignAreYouSureMsg = `This will remove Supervisor permissions for ${rowData.UserName}.
                            Reassign or remove their direct reports assignments prior to this change.`;
                            this.showAssignAreYouSure = true;
                        } else if (
                            rowData.GroupID == 12025 &&
                            rowData.selected == true
                        ) {
                            fp.assignAreYouSureMsg = `This will remove ${rowData.UserName} from the Task Manager role.
                            If ${rowData.UserName} has tasks assigned,
                            tasks assigned to ${rowData.UserName} must be removed or re-assigned before Task Manager role is removed.`;
                            this.showAssignAreYouSure = true;
                        } else if (
                            rowData.GroupID == 12030 &&
                            rowData.selected == true
                        ) {
                            fp.assignAreYouSureMsg = `This will remove ${rowData.UserName} as a Subcontractor.
                            Consultants assigned to ${rowData.UserName} must be removed or re-assigned before Subcontractor role is removed.`;
                            this.showAssignAreYouSure = true;
                        } else if (
                            rowData.GroupID == 1 &&
                            rowData.selected == true
                        ) {
                            fp.assignAreYouSureMsg = `This will remove ${rowData.UserName} from the Administrator role.`;
                            this.showAssignAreYouSure = true;
                        } else if (
                            rowData.GroupID == 12029 &&
                            rowData.selected == true
                        ) {
                            fp.assignAreYouSureMsg = `This will remove ${rowData.UserName} from the Report Admin role.`;
                            this.showAssignAreYouSure = true;
                        } else if (
                            rowData.GroupID == 12023 &&
                            rowData.selected == true
                        ) {
                            fp.assignAreYouSureMsg = `This will remove ${rowData.UserName} from the Process Admin role.`;
                            this.showAssignAreYouSure = true;
                        } else if (rowData.selected == true) {
                            fp.assignAreYouSureMsg = `This will remove ${rowData.UserName} from this group.`;
                            this.showAssignAreYouSure = true;
                        }

                        if (rowData.selected == false) {
                            row.update({ selected: true });
                            const group = fp.groupMembers.find(
                                x => x.ListID === rowData.ListID
                            );
                            const rowIndex = row.getPosition(true);
                            const allRows = this.tabGroupMembers.getRows();
                            let selectedCount = 0;
                            if (fp.selectedGroup.GroupID === 1) {
                                allRows.forEach(r => {
                                    const data = r.getData();
                                    if (
                                        fp.isMemberAssigned(data) &&
                                        !fp.isCertifiedAdvisor(data)
                                    ) {
                                        selectedCount++;
                                    }
                                });
                            }
                            if (rowData.IsGroupMember !== rowData.selected) {
                                if (rowData.IsGroupMember === true) {
                                    row.update({
                                        IsGroupMember: false,
                                        selected: false
                                    });
                                    fp.memberRowSelectUpdate.emit([
                                        {
                                            ...group,
                                            ...rowData
                                        }
                                    ]);
                                } else {
                                    if (rowData.GroupID === 1) {
                                        fp.confirmservice
                                            .confirmPromise({
                                                dialogText: `This will provide ${rowData.UserName} access to all features for all users and all contracts.`,
                                                okText: 'Confirm',
                                                cancelText: 'Cancel'
                                            })
                                            .then(() => {
                                                row.update({
                                                    IsGroupMember: true,
                                                    selected: true
                                                });
                                                fp.memberRowSelectUpdate.emit([
                                                    {
                                                        ...group,
                                                        ...rowData
                                                    }
                                                ]);
                                            })
                                            .catch(() => {
                                                row.update({
                                                    IsGroupMember: false,
                                                    selected: false
                                                });
                                            });
                                    } else {
                                        row.update({
                                            IsGroupMember: true,
                                            selected: true
                                        });
                                        fp.memberRowSelectUpdate.emit([
                                            {
                                                ...group,
                                                ...rowData
                                            }
                                        ]);
                                    }
                                }
                            } else {
                                if (fp.rolefromShared === 1) {
                                    if (
                                        !fp.isCertifiedAdvisor(rowData) &&
                                        selectedCount <= 1
                                    ) {
                                        fp.showAssignAdminPopup = true;
                                    } else {
                                        fp.confirmservice
                                            .confirmPromise({
                                                dialogText:
                                                    'Are you sure you want to remove this administrator?',
                                                okText: 'Yes',
                                                cancelText: 'No'
                                            })
                                            .then(() => {
                                                row.update({
                                                    IsGroupMember: false,
                                                    selected: false
                                                });
                                                fp.memberRowSelectUpdate.emit([
                                                    {
                                                        ...group,
                                                        ...rowData
                                                    }
                                                ]);
                                            })
                                            .catch(() => {});
                                    }
                                } else {
                                    row.update({
                                        IsGroupMember: false,
                                        selected: false
                                    });
                                    fp.memberRowSelectUpdate.emit([
                                        {
                                            ...group,
                                            ...rowData
                                        }
                                    ]);
                                }
                            }
                        }
                    }
                },
                {
                    title: 'Alternate <br/> Only',
                    field: 'IsAltSupervisorOnly',
                    formatter: 'tickCross',
                    formatterParams: {
                        crossElement: false
                    },
                    width: this.selectColumnWidth,
                    editor: false,
                    headerSort: true,
                    visible: false,
                    align: 'center'
                },
                // 3 Page Specific Columns
                {
                    title: '',
                    titleFormatter: () =>
                        document.getElementById('divMemberColumnHeader'),
                    field: 'UserName',
                    editor: false,
                    headerSort: false,
                    headerFilter: 'input',
                    minWidth: 200
                },
                {
                    title: '',
                    field: 'assign',
                    align: 'center',
                    visible: false,
                    headerSort: false,
                    width: 100,
                    formatter: cell => {
                        const row = cell.getRow();
                        const data = row.getData();
                        if (data.selected === false) {
                        } else {
                            if (data.GroupID === 12024) {
                                return "<a href='javascript:;'>Direct Reports</a>";
                            }
                            if (data.GroupID === 12025) {
                                return "<a href='javascript:;'>Tasks</a>";
                            }
                            if (data.GroupID === 12030) {
                                return "<a href='javascript:;'>Consultants</a>";
                            }
                        }
                    },
                    cellClick: function (e, cell) {
                        const row = cell.getRow();
                        const data = row.getData();
                        const allRows = this.getRows();

                        fp.elementSelected = false;
                        if (data.GroupID === 12024) {
                            fp.assignedEleColumnHeader = `Assigned <br/>Direct Report`;
                            fp.eleSwitchDesc =
                                'Display Assigned Direct Reports Only';
                            fp.elementColumnHeader = `${data.UserName}'s Direct Reports`;
                        }
                        if (data.GroupID === 12025) {
                            fp.assignedEleColumnHeader = `Assigned <br/>Tasks`;
                            fp.eleSwitchDesc = 'Display Assigned Tasks Only';
                            fp.elementColumnHeader = `${data.UserName}'s Tasks`;
                        }
                        if (data.GroupID === 12030) {
                            fp.assignedEleColumnHeader = `Assigned <br/>Consultants`;
                            fp.eleSwitchDesc =
                                'Display Assigned Consultants Only';
                            fp.elementColumnHeader = `${data.UserName}'s Consultants`;
                        }
                        fp.supervisorListID = data.ListID;
                        if (data.GroupID === 12024 || data.GroupID === 12030) {
                            if (data.selected === true) {
                                let index = 0;

                                for (
                                    let i = 0;
                                    i < fp.groupElementTypes.length;
                                    i++
                                ) {
                                    if (
                                        fp.groupElementTypes[i]
                                            .GroupElementTypeID === 6
                                    ) {
                                        index = i;
                                    }
                                }

                                if (
                                    fp.groupElementTypes[index]
                                        .GroupElementType === 'Users'
                                ) {
                                    fp.groupElementTypes[
                                        index
                                    ].GroupElementType = 'Direct Reports';
                                }
                                fp.elementsCheckboxFlag = false;
                                fp.groupElementTypes[index].ListID =
                                    data.ListID;
                                fp.selectElement.emit(
                                    fp.groupElementTypes[index]
                                );
                            }
                        }
                        if (data.GroupID === 12025) {
                            if (data.selected === true) {
                                let index = 0;
                                for (
                                    let i = 0;
                                    i < fp.groupElementTypes.length;
                                    i++
                                ) {
                                    if (
                                        data.GroupID ===
                                        fp.groupElementTypes[i].GroupID
                                    ) {
                                        index = i;
                                    }
                                }
                                fp.elementsCheckboxFlag = false;
                                fp.groupElementTypes[index].ListID =
                                    data.ListID;
                                fp.selectElement.emit(
                                    fp.groupElementTypes[index]
                                );
                            }
                        }
                    }
                },
                {
                    title: 'Assigned <br/>Alt for all Supervisors',
                    field: 'IsAltForAllSupervisors',
                    headerSort: false,
                    align: 'center',
                    width: 125,
                    formatter: 'tickCross',
                    formatterParams: { crossElement: false },
                    editor: false,
                    visible: false,
                    selectablePersistence: false,
                    cellClick: (e, cell) => {
                        const row = cell.getRow();
                        const rowData = row.getData();
                        const data = fp.groupMembers.find(
                            x => x.ListID === rowData.ListID
                        );
                        const status = cell.getValue();
                        if (rowData.IsGroupMember === true) {
                            if (rowData.IsAltForAllSupervisors == true) {
                                fp.confirmservice
                                    .confirmPromise({
                                        headerText: 'Are you sure?',
                                        dialogText:
                                            'This will remove Alternate Supervisor access.',
                                        okText: 'Ok',
                                        cancelText: 'Cancel'
                                    })
                                    .then(() => {
                                        if (status === true) {
                                            row.update({
                                                IsAltForAllSupervisors: false
                                            });
                                            fp.memberRowSelectUpdate.emit([
                                                {
                                                    ...data,
                                                    ...rowData
                                                }
                                            ]);
                                        } else {
                                            row.update({
                                                IsAltForAllSupervisors: true
                                            });
                                            fp.memberRowSelectUpdate.emit([
                                                {
                                                    ...data,
                                                    ...rowData
                                                }
                                            ]);
                                        }
                                    })
                                    .catch(() => {});
                            } else {
                                if (status === true) {
                                    row.update({
                                        IsAltForAllSupervisors: false
                                    });
                                    fp.memberRowSelectUpdate.emit([
                                        {
                                            ...data,
                                            ...rowData
                                        }
                                    ]);
                                } else {
                                    row.update({
                                        IsAltForAllSupervisors: true
                                    });
                                    fp.memberRowSelectUpdate.emit([
                                        {
                                            ...data,
                                            ...rowData
                                        }
                                    ]);
                                }
                            }
                        } else {
                            // Do nothing. Cell should be protected.
                        }
                    }
                },
                {
                    title: '',
                    field: 'alt',
                    align: 'center',
                    visible: false,
                    headerSort: false,
                    width: 100,
                    formatter: cell => {
                        const row = cell.getRow();
                        const data = row.getData();
                        if (data.selected === false) {
                        } else {
                            if (data.GroupID === 12024) {
                                if (
                                    data.IsAltSupervisorOnly == false ||
                                    data.IsAltSupervisorOnly == null
                                ) {
                                    return "<a href='javascript:;'>My Alternates</a>";
                                }
                            }
                        }
                    },
                    cellClick: function (e, cell) {
                        e.stopPropagation();
                        const row = cell.getRow();
                        row.toggleSelect();
                        const data = row.getData();
                        const allRows = this.getRows();
                        if (
                            data.IsAltSupervisorOnly == false ||
                            data.IsAltSupervisorOnly == null
                        ) {
                            fp.assignedEleColumnHeader = `Assigned <br/>Alternate`;
                            fp.eleSwitchDesc =
                                'Display Assigned Alternates Only';
                            fp.elementSelected = false;
                            fp.supervisorListID = data.ListID;
                            if (data.GroupID === 12024) {
                                if (data.selected === true) {
                                    let index = 0;
                                    for (
                                        let i = 0;
                                        i < fp.groupElementTypes.length;
                                        i++
                                    ) {
                                        if (
                                            fp.groupElementTypes[i]
                                                .GroupElementTypeID === 9
                                        ) {
                                            index = i;
                                        }
                                    }
                                    fp.elementColumnHeader = `${data.UserName}'s ${fp.groupElementTypes[index].GroupElementType}s`;
                                    fp.groupElementTypes[index].ListID =
                                        data.ListID;
                                    fp.selectElement.emit(
                                        fp.groupElementTypes[index]
                                    );
                                }
                            }
                        }
                    }
                },
                {
                    title: '',
                    field: 'altFor',
                    align: 'center',
                    visible: false,
                    headerSort: false,
                    width: 100,
                    formatter: cell => {
                        const row = cell.getRow();
                        const data = row.getData();
                        if (data.selected === false) {
                        } else {
                            if (data.GroupID === 12024) {
                                return "<a href='javascript:;'>Alternate For</a>";
                            }
                        }
                    },
                    cellClick: function (e, cell) {
                        e.stopPropagation();
                        const row = cell.getRow();
                        row.toggleSelect();
                        const data = row.getData();
                        const allRows = this.getRows();
                        fp.assignedEleColumnHeader = `Assigned <br/>Alternate For`;
                        fp.eleSwitchDesc = 'Display Assigned Alternates Only';
                        fp.elementSelected = false;
                        fp.supervisorListID = data.ListID;
                        if (data.GroupID === 12024) {
                            if (data.selected === true) {
                                let altForIndex = 0;
                                for (
                                    let i = 0;
                                    i < fp.groupElementTypes.length;
                                    i++
                                ) {
                                    if (
                                        fp.groupElementTypes[i]
                                            .GroupElementTypeID === 10
                                    ) {
                                        altForIndex = i;
                                    }
                                }
                                fp.elementColumnHeader = `${data.UserName} is an ${fp.groupElementTypes[altForIndex].GroupElementType}`;
                                fp.groupElementTypes[altForIndex].ListID =
                                    data.ListID;
                                fp.selectElement.emit(
                                    fp.groupElementTypes[altForIndex]
                                );
                            }
                        }
                        // this.createTabulatorForElements(this, this.groupElements, []);
                    }
                },
                {
                    title: 'Assigned <br/> SuperUser',
                    field: 'AllowSuperUser',
                    formatter: 'tickCross',
                    headerSort: false,
                    formatterParams: { crossElement: false },
                    width: fp.selectColumnWidth,
                    align: 'center',
                    visible: false,
                    cellClick: function (e, cell) {
                        const row = cell.getRow();
                        const rowData = row.getData();

                        const data = fp.groupMembers.find(
                            x => x.ListID === rowData.ListID
                        );
                        const status = cell.getValue();
                        if (rowData.IsGroupMember === true) {
                            if (rowData.AllowSuperUser == true) {
                                fp.confirmservice
                                    .confirmPromise({
                                        headerText: 'Are you sure?',
                                        dialogText:
                                            'This will remove Super User permissions.',
                                        okText: 'Ok',
                                        cancelText: 'Cancel'
                                    })
                                    .then(() => {
                                        if (status === true) {
                                            row.update({
                                                AllowSuperUser: false
                                            });
                                            fp.memberRowSelectUpdate.emit([
                                                {
                                                    ...data,
                                                    ...rowData
                                                }
                                            ]);
                                        } else {
                                            row.update({
                                                AllowSuperUser: true
                                            });
                                            fp.memberRowSelectUpdate.emit([
                                                {
                                                    ...data,
                                                    ...rowData
                                                }
                                            ]);
                                        }
                                    })
                                    .catch(() => {});
                            } else {
                                if (status === true) {
                                    row.update({ AllowSuperUser: false });
                                    fp.memberRowSelectUpdate.emit([
                                        {
                                            ...data,
                                            ...rowData
                                        }
                                    ]);
                                } else {
                                    row.update({ AllowSuperUser: true });
                                    fp.memberRowSelectUpdate.emit([
                                        {
                                            ...data,
                                            ...rowData
                                        }
                                    ]);
                                }
                            }
                        } else {
                            // Do nothing. Cell should be protected.
                        }
                    }
                },
                {
                    title: 'Access to <br/> Authorizations',
                    field: 'Allowauths',
                    formatter: 'tickCross',
                    headerSort: false,
                    formatterParams: { crossElement: false },
                    width: fp.selectColumnWidth,
                    align: 'center',
                    visible: false,
                    cellClick: function (e, cell) {
                        const row = cell.getRow();
                        const rowData = row.getData();
                        const data = fp.groupMembers.find(
                            x => x.ListID === rowData.ListID
                        );
                        const status = cell.getValue();
                        if (rowData.IsGroupMember === true) {
                            if (rowData.Allowauths == true) {
                                fp.confirmservice
                                    .confirmPromise({
                                        headerText: 'Are you sure?',
                                        dialogText:
                                            'This will remove Access to Authorizations.',
                                        okText: 'Ok',
                                        cancelText: 'Cancel'
                                    })
                                    .then(() => {
                                        if (status === true) {
                                            row.update({ Allowauths: false });
                                            fp.memberRowSelectUpdate.emit([
                                                {
                                                    ...data,
                                                    ...rowData
                                                }
                                            ]);
                                        } else {
                                            row.update({ Allowauths: true });
                                            fp.memberRowSelectUpdate.emit([
                                                {
                                                    ...data,
                                                    ...rowData
                                                }
                                            ]);
                                        }
                                    })
                                    .catch(() => {});
                            } else {
                                if (status === true) {
                                    row.update({ Allowauths: false });
                                    fp.memberRowSelectUpdate.emit([
                                        {
                                            ...data,
                                            ...rowData
                                        }
                                    ]);
                                } else {
                                    row.update({ Allowauths: true });
                                    fp.memberRowSelectUpdate.emit([
                                        {
                                            ...data,
                                            ...rowData
                                        }
                                    ]);
                                }
                            }
                        } else {
                            // Do nothing. Cell should be protected.
                        }
                    }
                },
                {
                    title: '',
                    field: 'Row_Version',
                    visible: false
                }
            ],
            rowSelected: function (row) {
                fp.membersRowSelection(row, this);
            },
            rowDeselected: function (row) {},
            cellEdited: this.tabService.cellEdited,
            cellEditing: this.tabService.cellEditing,
            cellClick: this.tabService.cellMouseHandler,
            cellTap: this.tabService.cellMouseHandler,
            rowClick: this.tabService.rowMouseHandler,
            rowTap: this.tabService.rowMouseHandler
        });
    }

    assignAllElementsClicked() {
        this.assignAll = true;
        this.unassignAll = false;
        const elements = this.getBulkOperationElements();
        const numOfNotSelectedRows = elements.filter(
            element => element.IsGroupElement !== true
        ).length;
        if (numOfNotSelectedRows > 0) {
            if (this.process.ProcessID == 140) {
                this.selectNotificationText = `"Assign All" will impact all assignments, are you sure?`;
            } else {
                this.selectNotificationText = `"Assign All" will "REPLACE ALL" existing assignments. Are you sure?`;
            }

            $('#divSelectAllElements').fadeIn(500);
            this.showElementSelectAllConfirmation = true;
        }
    }

    unassignAllElementsClicked() {
        this.assignAll = false;
        this.unassignAll = true;
        const elements = this.getBulkOperationElements();
        const numOfSelectedRows = elements.filter(
            element => element.IsGroupElement === true
        ).length;
        if (numOfSelectedRows > 0) {
            if (this.process.ProcessID == 140) {
                this.selectNotificationText = `"Unassign All" will impact all assignments, are you sure?`;
            } else {
                this.selectNotificationText = `"Unassign All" will "REPLACE ALL" existing assignments. Are you sure?`;
            }
            $('#divSelectAllElements').fadeIn(500);
            this.showElementSelectAllConfirmation = true;
        } else {
        }
    }

    assignAllMembersClicked() {
        this.assignAll = true;
        const members = this.getBulkOperationMembers();
        const numOfNotSelectedRows = members.filter(
            member => member.IsGroupMember !== true
        ).length;
        if (numOfNotSelectedRows > 0) {
            this.selectNotificationText = `"Assign All" will impact all assignments, are you sure?`;
            $('#divSelectAllMembers').fadeIn(500);
            this.showMemberSelectAllConfirmation = true;
        }
    }

    unassignAllMembersClicked() {
        this.assignAll = false;
        const members = this.getBulkOperationMembers();
        const numOfSelectedRows = members.filter(
            member => member.IsGroupMember === true
        ).length;
        if (numOfSelectedRows > 0) {
            this.selectNotificationText = `"Unassign All" will impact all assignments, are you sure?`;
            $('#divSelectAllMembers').fadeIn(500);
            this.showMemberSelectAllConfirmation = true;
        } else {
        }
    }
    assignAllElements() {
        this.showElementSelectAllConfirmation = false;
        this.applyBulkElementUpdates(this.unassignAll !== true);
        this.assignAll = false;
        this.unassignAll = false;
    }

    assignAllMembers() {
        this.showMemberSelectAllConfirmation = false;
        this.applyBulkMemberUpdates(this.assignAll === true);
        this.assignAll = false;
    }
    unassignAllElements() {

    }

    unassignAllMembers() {

    }

    private createTabulatorForElements(
        fp: GroupsPresentersComponent,
        elements: Array<IGroupElement>,
        errors: Array<string>
    ) {
        this.tabElements = this.buildTableAdapter(
            () => this.groupElements,
            'GroupElementID',
            'selected',
            () => this.elementNameFilter
        );
        return;
        const headerClicked = false;

        this.tabElements = new Tabulator('#tabElements', {
            placeholder: 'No Data Available',
            height: '45vh',
            autoResize: true,
            layout: 'fitColumns',
            // visible: fp.HasElements,
            data: elements,
            columns: [
                {
                    title: 'Id',
                    field: 'GroupElementID',
                    frozen: true,
                    visible: false
                },

                {
                    title: 'Assigned',//this.assignedEleColumnHeader,
                    field: 'selected',
                    headerSort: false,
                    editor: false,
                    align: 'center',
                    width: this.selectColumnWidth,
                    formatter: 'tickCross',
                    formatterParams: { crossElement: false },
                    selectablePersistence: false,
                    cellClick: (e, cell) => {
                        const row = cell.getRow();
                        row.toggleSelect();
                    }
                },
                // 3 Page Specific Columns
                {
                    title: '',
                    titleFormatter: () =>
                        document.getElementById('divElementColumnHeader'),
                    field: 'ElementName',
                    cssClass: 'tabulator-cell-readonly disabled',
                    editor: false,
                    headerFilter: 'input',
                    minWidth: 200
                },
                {
                    title: '',
                    field: 'Row_Version',
                    visible: false
                }
            ],
            rowSelected: function (row) {
                row.update({ selected: true });

                const rowData = row.getData();
                const rowIndex = row.getPosition(true);

                const data = fp.groupElements.find(
                    x => x.GroupElementID === rowData.GroupElementID
                );

                if (rowData.IsGroupElement !== rowData.selected) {
                    if (rowData.IsGroupElement === true) {
                        row.update({
                            IsGroupElement: false,
                            selected: false,
                            ListID: fp.supervisorListID
                        });
                    } else {
                        row.update({
                            IsGroupElement: true,
                            selected: true,
                            ListID: fp.supervisorListID
                        });
                    }

                    if (fp.rolefromShared === 12030) {
                        if (rowData.ElementName.includes('(')) {
                            // var elementName = rowData.ElementName.split('(');
                            // var name = elementName[0];
                            fp.confirmservice
                                .confirmPromise({
                                    dialogText:
                                        'Are you sure you want to remove ' +
                                        rowData.ElementName +
                                        ' from current assignment and add them to the new subcontractor group?',
                                    okText: 'Yes',
                                    cancelText: 'No'
                                })
                                .then(() => {
                                    row.update({
                                        IsGroupElement: true,
                                        selected: true
                                    });
                                    fp.elementRowSelectUpdate.emit([
                                        {
                                            ...data,
                                            ...rowData
                                        }
                                    ]);
                                })
                                .catch(() => {
                                    row.update({
                                        IsGroupElement: false,
                                        selected: false
                                    });
                                });
                        } else {
                            fp.elementRowSelectUpdate.emit([
                                {
                                    ...data,
                                    ...rowData
                                }
                            ]);
                        }
                    } else {
                        fp.elementRowSelectUpdate.emit([
                            {
                                ...data,
                                ...rowData
                            }
                        ]);
                    }
                } else {
                    row.update({
                        IsGroupElement: false,
                        selected: false,
                        ListID: fp.supervisorListID
                    });
                    fp.elementRowSelectUpdate.emit([
                        {
                            ...data,
                            ...rowData
                        }
                    ]);
                }

                fp.LoadMembers.next({ GroupID: data.GroupID, IsGroupMember: null });
            },
            rowDeselected: function (row) {
                row.update({ selected: false });
            },
            cellEdited: this.tabService.cellEdited,
            cellEditing: this.tabService.cellEditing,
            cellClick: this.tabService.cellMouseHandler,
            cellTap: this.tabService.cellMouseHandler,
            rowClick: this.tabService.rowMouseHandler,
            rowTap: this.tabService.rowMouseHandler
        });
    }

    public onToggleShowSelected(e: MatSlideToggleChange) {
        this.log.debug({
            type: 'FixedPriceListComponent:onToggleShowSelected',
            e
        });

        if (e.checked === true) {
            this.showSelectedRowsOnly = true;
            this.filterdata();
        } else {
            this.showSelectedRowsOnly = false;
            this.tabGroupMembers.clearFilter();
            this.tabElements.clearFilter();
        }
    }
    public onToggleShowSelectedEle(e: MatSlideToggleChange) {
        this.log.debug({
            type: 'FixedPriceListComponent:onToggleShowSelectedEle',
            e
        });

        if (e.checked === true) {
            this.showSelectedEleRowsOnly = true;
            this.filterEleData();
        } else {
            this.showSelectedEleRowsOnly = false;
            this.tabElements.clearFilter();
        }
    }

    public checkIndeterminate(
        tab: any,
        cbxColumnHeader: any,
        list: Array<any>,
        count: number
    ) {
        if (this.groupMembers.length > 0 || this.groupElements.length > 0) {
            if (tab) {
                const rows = tab.getRows(true);
                const selectedRows: Array<any> = [];
                rows.forEach(row => {
                    if (row._row.data.selected === true) {
                        selectedRows.push(row);
                    }
                });

                cbxColumnHeader.checked = rows.reduce(
                    (a, c) => a && c.getData().selected,
                    true
                );
                cbxColumnHeader.indeterminate =
                    selectedRows.length > 0 &&
                    !rows.reduce((a, c) => a && c.getData().selected, true);
            }
        }
    }

    filterdata() {
        this.tabGroupMembers.clearFilter();

        const membersFiltersToApply: Array<{
            field: string;
            type: string;
            value: any;
        }> = [];

        this.groupMembers.forEach(mem => {
            membersFiltersToApply.push({
                field: 'selected',
                type: '=',
                value: true
            });
        });

        this.tabGroupMembers.setFilter(membersFiltersToApply);
    }

    filterEleData() {
        this.tabElements.clearFilter();

        const elementsFiltersToApply: Array<{
            field: string;
            type: string;
            value: any;
        }> = [];

        this.groupElements.forEach(ele => {
            elementsFiltersToApply.push({
                field: 'selected',
                type: '=',
                value: true
            });
        });

        this.tabElements.setFilter(elementsFiltersToApply);
    }

    public clearFilters() {
        this.resetPageToInitialState();
    }

    public resetPageToInitialState(): void {
        this.deleteVisible = false;
        this.selectedGroup = null;
        this.purpose = '';
        this.memberNameFilter = '';
        this.elementNameFilter = '';
        this.showSelectedRowsOnly = false;
        this.showSelectedEleRowsOnly = false;
        this.loadingData = false;
        this.groupMembersORIG = [];
        this.groupElementsORIG = [];
        this.filteredMembers = [];

        if (this.tabGroupMembers) {
            this.createTabulatorForGroupMembers(this, [], []);
        }
        if (this.tabElements) {
            this.createTabulatorForElements(this, [], []);
        }

        if (this.membersCbxColumnHeader) {
            this.membersCbxColumnHeader.indeterminate = false;
            this.membersCbxColumnHeader.checked = false;
        }
        if (this.elementsCbxColumnHeader) {
            this.elementsCbxColumnHeader.indeterminate = false;
            this.elementsCbxColumnHeader.checked = false;
        }

        this.filterFormGroup.controls['elementTypes'].reset();
        this.filterFormGroup.controls['groups'].reset();
        this.filterFormGroup.controls['purpose'].reset();
        this.filterFormGroup.controls['groupTypes'].reset();
    }
}
